import { render, staticRenderFns } from "./SafetyInspectionPanel.vue?vue&type=template&id=316bf444"
import script from "./SafetyInspectionPanel.vue?vue&type=script&lang=js"
export * from "./SafetyInspectionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports